export const en = {
	translation: {
		Бали: 'Points',
		Замовлено: 'Reserved',
		'створити накладну': 'create invoice',
		'список накладних': 'list of invoices',
		'Моя команда': 'My Team',
		'Зміна пароля': 'Change Password',
		'Введіть старий пароль': 'Enter old password',
		'Введіть новий пароль': 'Enter new password',
		'Старий пароль вірний': 'Old password is correct',
		'Невірний старий пароль': 'Invalid old password',
		'Спочатку підтвердіть старий пароль': 'Please confirm old password first',
		'Показати пароль': 'Show password',
		'Сховати пароль': 'Hide password',
		'Повернутися на головну': 'Return to home',
		'Спробувати ще раз': 'Try again',
		'От халепа!': 'Whoops!',
		'Деталі для підтримки': 'Details for support',
		'Повідомлення': 'Message',
		'Сторінку не знайдено': 'Page not found',
		'Такої сторінки не існує або вона була переміщена. Перевірте коректність адреси або поверніться на головну.':
			'The page you are looking for does not exist or has been moved. Check the URL or return to the home page.',
		'Повернутися назад': 'Go back',
		Дата: 'Date',
		Активован: 'Activated',
		Контракт: 'Contract',
		"Ім'я": 'Name',
		Спонсор: 'Sponsor',
		Чоловік: 'Male',
		Жінка: 'Female',
		"Тут з'явиться інформація коли ви зареєструєте клієнтів в свою мережу.":
			'Information will appear here when you register clients in your network.',
		Україна: 'Ukraine',
		клієнта: 'client',
		партнера: 'partner',
		Клієнт: 'Client',
		Партнер: 'Partner',
		'Тип новачка': 'Newcomer type',
		Країна: 'Country',
		'Статуту компанії': 'Company statute',
		'реєстрація клієнта': 'client registration',
		'реєстрація партнера': 'partner registration',
		'зареєструвати клієнта': 'register client',
		'зареєструвати партнера': 'register partner',
		Валюта: 'Currency',
		'Номер контракту': 'Contract number',
		'Дата народження': 'Date of birth',
		МІСТО: 'CITY',
		КОНТАКТ: 'CONTACT',
		'Особистий ТО': 'Personal TO',
		'Командний ТО': 'Team TO',
		'Дата Реєстрації': 'Registration date',
		Кваліфікація: 'Qualification',
		'Клієнтів в дереві': 'Clients in tree',
		Видалити: 'Delete',
		редагувати: 'edit',
		Закрити: 'Close',
		Застосувати: 'Apply',
		Очистити: 'Clear',
		Харків: 'Kharkiv',
		'Дивитися більше': 'See more',
		'Дивитись більше': 'See more',
		Підтвердити: 'Confirm',
		'Конвертація ': 'Conversion ',
		'Отримання коштів': 'Fund withdrawal',
		'Переведено до мене': 'Transferred to me',
		'Переведено від мене': 'Transferred from me',
		закрити: 'close',
		'додати фільтр': 'add filter',
		Відкрити: 'Open',
		'Підтвердження залишків продукції на складі': 'Confirmation of product balances in warehouse',
		'Мій дохід з мережі': 'My network income',
		'Оберіть місяць': 'Select month',
		Січень: 'January',
		Лютий: 'February',
		Березень: 'March',
		Квітень: 'April',
		Травень: 'May',
		Червень: 'June',
		Липень: 'July',
		Серпень: 'August',
		Вересень: 'September',
		Жовтень: 'October',
		Листопад: 'November',
		Грудень: 'December',
		'На початок': 'At start',
		Прихід: 'Income',
		Повернення: 'Return',
		Оформлення: 'Registration',
		'На кінець': 'At end',
		Далі: 'Next',
		Баланс: 'Balance',
		'Таблиця руху товару': 'Product movement table',
		'Вид дії': 'Action type',
		'Різниця сумарного по дням командного обсягу між поточним місяцем та цього самого дня минулого місяця':
			'Difference in total team volume by days between current month and the same day of previous month',
		'з {{from}} до {{to}}': 'from {{from}} to {{to}}',
		Рівень: 'Level',
		Всього: 'Total',
		Всі: 'All',
		Дні: 'Days',
		Місяці: 'Months',
		'Кількість': 'Quantity',
		'Лідери команди': 'Team leaders',
		'ЛИЧНОГО ОБЬЕМА': 'PERSONAL VOLUME',
		'Команда (новачки)': 'Team (newbies)',
		видалено: 'deleted',
		зареєстровано: 'registered',
		'Мережа клієнтів': 'Client network',
		'Розподіл кваліфікацій за рівнями': 'Qualification distribution by levels',
		лiнiя: 'line',
		'Історія маркетингплану': 'Marketing plan history',
		'Історія кваліфікацій': 'Qualification history',
		'Особистий профіль': 'Personal profile',
		'Основна інформація': 'Basic information',
		Прізвище: 'Surname',
		'По батькові': 'Middle name',
		Стать: 'Gender',
		Чоловіча: 'Male',
		Жіноча: 'Female',
		'Електронна пошта': 'Email',
		Область: 'Region',
		Місто: 'City',
		Адреса: 'Address',
		'Посилання на соціальні мережі': 'Social media links',
		'Введіть посилання': 'Enter link',
		'Телефон для контактів': 'Contact phone',
		Телефон: 'Phone',
		'ЗБЕРЕГТИ ЗМІНИ': 'SAVE CHANGES',
		Разом: 'Together',
		'Сум 5': 'Sum 5',
		'Сум 6': 'Sum 6',
		'Сум 7': 'Sum 7',
		'Середній показник за день': 'Average per day',
		'Вхід у кабінет': 'Login to cabinet',
		Вихід: 'Logout',
		'Мій бізнес': 'My business',
		'Мій партнерський дохід': 'My partner income',
		'Мої замовлення': 'My orders',
		'Мої замовлення Менеджер': 'My orders Manager',
		'Моя динаміка': 'My dynamics',
		Склад: 'Warehouse',
		'До сайту': 'To site',
		Головна: 'Home',
		Магазин: 'Store',
		'Про компанію': 'About company',
		Виробники: 'Manufacturers',
		Контакти: 'Contacts',
		Каталог: 'Catalog',
		Інформація: 'Information',
		Мова: 'Language',
		'Список накладних': 'List of invoices',
		'Список товарів': 'List of products',
		'Список оформлень': 'List of registrations',
		'Список бонусів': 'List of bonuses',
		'Список касових ордерів': 'List of cash orders',
		'Фінансовий звіт': 'Financial report',
		Новини: 'News',
		Навчання: 'Education',
		Медіабаза: 'Media base',
		'Академія розвитку': 'Development academy',
		'Оберіть місяць ': 'Select month ',
		'Вибір місяця': 'Select month',
		Бонусів: 'Bonuses',
		бонусів: 'bonuses',
		'Бонуси за цей місяць відсутні': 'No bonuses for this month',
		Замовлення: 'Order',
		'Введіть текст для пошуку...': 'Enter text to search...',
		'Перемістити в дереві': 'Move in tree',
		'Оформити бали': 'Register points',
		'Підтвердження номера': 'Number confirmation',
		'Підтвердіть зміну номера': 'Confirm number change',
		'ОТРИМАТИ смс': 'GET SMS',
		'СКАСУВАТИ НОМЕР': 'CANCEL NUMBER',
		'Код СМС': 'SMS code',
		Відправити: 'Send',
		'Мій бонусний рахунок': 'My bonus account',
		'В цьому місяці вам нараховано премію': 'This month you have been awarded a bonus',
		'За виконання умов бонусної програми та': 'For fulfilling the bonus program conditions and',
		'умов отримання премій': 'bonus receiving conditions',
		'До наступної премії тобі залишилось сумарно': 'Until the next bonus you have left in total',
		Балів: 'Points',
		'в двох гілках': 'in two branches',
		'розмір наступної премії': 'next bonus amount',
		'Мої рахунки': 'My accounts',
		'Переглянути транзакції': 'View transactions',
		'Виведення винагороди': 'Reward withdrawal',
		Переказ: 'Transfer',
		Конвертація: 'Conversion',
		'Введіть число': 'Enter number',
		'Недостатньо коштів': 'Insufficient funds',
		Міняю: 'I exchange',
		Отримую: 'I receive',
		Доступно: 'Available',
		грн: 'UAH',
		'Мій рахунок': 'My account',
		'Рахунок отримувача': 'Recipient account',
		'Вибір валюти': 'Currency selection',
		Сума: 'Amount',
		'Введіть бажану суму': 'Enter desired amount',
		'Доступно для переказу': 'Available for transfer',
		'Виберіть рахунок': 'Select account',
		'Партнери у кваліфікації': 'Partners in qualification',
		'До наступної кваліфікації вам потрібно': 'Until the next qualification you need',
		'Найближча кваліфікація': 'Nearest qualification',
		Дивитися: 'View',
		'Мої реферальні посилання': 'My referral links',
		'Поточна кваліфікація': 'Current qualification',
		назад: 'back',
		підтверджено: 'confirmed',
		відхилено: 'rejected',
		сплачено: 'paid',
		відкладене: 'deferred',
		звичайне: 'regular',
		Назва: 'Name',
		'Всього вартість': 'Total cost',
		'Всього бали': 'Total points',
		'Загальна кількість балів': 'Total number of points',
		'Загальна вартість замовлення': 'Total order cost',
		'Розмір кешбека': 'Cashback amount',
		'з них оплачено бонусами': 'of which paid with bonuses',
		'Ваш обраний товар': 'Your selected product',
		'Загальна вага': 'Total weight',
		'Немає результатів': 'No results',
		'Клієнт з таким номером контрактом вже втратив контракт':
			'Client with this contract number has already lost the contract',
		'Клієнт в дереві': 'Client in tree',
		'Контракт не в вашій структурі': 'Contract is not in your structure',
		'Клієнт не активний': 'Client is not active',
		'Клієнт активний на': 'Client is active on',
		'Контракт партнера': 'Partner contract',
		'Мої клієнти': 'My clients',
		'Зареєструвати заново': 'Register again',
		'На бонусному рахунку клієнта': 'On client bonus account',
		'Введіть номер контракту': 'Enter contract number',
		"Дерево дистриб'юторів": "Distributors' tree",
		'Вибір клієнта': 'Client selection',
		Чернетка: 'Draft',
		Нове: 'New',
		Відхилено: 'Rejected',
		Підтверджено: 'Approved',
		Збирається: 'Collecting',
		Запаковано: 'Packaged',
		Відправлено: 'Shipped',
		Отримано: 'Received',
		Звичайне: 'Regular',
		Відкладене: 'Deferred',
		Обрати: 'Select',
		'Оберіть місто': 'Select city',
		Відділення: 'Branch',
		Поштомат: 'Postomat',
		'Оберіть область': 'Select region',
		'Дохід від побудови власної мережі': 'Income from building own network',
		'Нараховано цього місяця': 'Accrued this month',
		'Дохід CashBack': 'CashBack income',
		'Архів Cashback': 'Cashback archive',
		'Дохід за програмою Optima': 'Income from Optima program',
		'ВСІ OPTIMA': 'ALL OPTIMA',
		'Сторінка недоступна': 'Page unavailable',
		'І він складається з:\n1) Дохід від побудови власної мережі\n2) Дохід CashBack \n3) Дохід за програмою OPTIMA\n':
			'And it consists of:\n1) Income from building own network\n2) CashBack income \n3) Income from OPTIMA program\n',
		'Мій партнерський дохід — це загальна сума всіх винагород, які ви отримуєте від співпраці з компанією CHOICE:\n':
			'My partner income is the total amount of all rewards you receive from cooperation with CHOICE company:\n',
		'«Натискаючи «Зареєструвати», Ви підтверджуєте, що ознайомлені з положеннями та умовами»':
			'By clicking "Register", you confirm that you are familiar with the terms and conditions',
		Покупець: 'Buyer',
		'Ви авторизовані як': 'You are authorized as',
		'номер лояльності': 'loyalty number',
		'За цей місяць у Вас вже зараховано': 'This month you have already been credited',
		Б: 'B',
		'про свою активність Ви можете переглянути на сторінці': 'about your activity you can view on the page',
		кабінету: 'cabinet',
		'Якщо Ви хочете надалі оформити ці бали на своїх партнерів, то поставте нижче позначку':
			'If you want to register these points on your partners in the future, check the box below',
		'зробити відкладеним оформленням': 'make deferred registration',
		'Виберіть контакт зі списку': 'Select contact from list',
		'Коментар до замовлення': 'Order comment',
		'Введіть текст': 'Enter text',
		'Я прочитав/прочитала і прийняв/прийняла повідомлення і текст згоди з Умовами та Політикою захисту даних':
			'I have read and accepted the message and consent text with Terms and Privacy Policy',
		'Оформити замовлення': 'Place order',
		'Відхилити': 'Reject',
		'Підтвердження отримання коштів': 'Confirmation of funds receipt',
		'Підтвердити оплату': 'Confirm payment',
		'Введіть новий контакт': 'Enter new contact',
		Город: 'City',
		Отделение: 'Branch',
		'Выберите имя получателя': 'Select recipient name',
		'Выберите способ оплаты': 'Select payment method',
		'Реєстрація партнера/клієнта': 'Register partner/client',
		'byCHOICE.BOT': 'byCHOICE.BOT',
		'За вказаний період дані відсутні': 'No data for the selected period',
	},
};
